import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { useToast } from "../hooks/use-toast";
import { Send } from "lucide-react";

const QuoteDialog = ({ open, onOpenChange }) => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", phone: "", email: "", service: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast({ title: "Missing info", description: "Please enter your name and phone number." });
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      try {
        const existing = JSON.parse(localStorage.getItem("quotes") || "[]");
        existing.push({ ...form, date: new Date().toISOString() });
        localStorage.setItem("quotes", JSON.stringify(existing));
      } catch (err) {}
      setSubmitting(false);
      toast({ title: "Quote requested!", description: "We'll get back to you within 24 hours." });
      setForm({ name: "", phone: "", email: "", service: "", message: "" });
      onOpenChange(false);
    }, 700);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle className="text-[#0f2a5c] text-2xl font-extrabold">Get a Free Quote</DialogTitle>
          <DialogDescription>
            Fill in your details and our team will reach out to you shortly.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-2">
          <div>
            <Label htmlFor="name">Full Name *</Label>
            <Input id="name" name="name" value={form.name} onChange={handleChange} placeholder="Your name" className="mt-1" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label htmlFor="phone">Phone *</Label>
              <Input id="phone" name="phone" value={form.phone} onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="mt-1" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@email.com" className="mt-1" />
            </div>
          </div>
          <div>
            <Label htmlFor="service">Service Interested In</Label>
            <Input id="service" name="service" value={form.service} onChange={handleChange} placeholder="Solar Installation / Panels ..." className="mt-1" />
          </div>
          <div>
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your project..." className="mt-1" rows={3} />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#F5B800] hover:bg-[#e0a800] disabled:opacity-60 text-[#0f2a5c] font-semibold px-6 py-3 rounded-md transition-colors shadow-md"
          >
            <Send className="w-4 h-4" />
            {submitting ? "Submitting..." : "Submit Request"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default QuoteDialog;
